import { returnResponse } from './baseReducer';

const initialState = {
    activePage: null
};

export default function menuReducer(state = {}, action) {
    return returnResponse(state, action);     
}